
import Vue from 'vue';
import IRow from '@/pages/search/results/table/IRow.vue';
import { DocRowData } from '@/pages/search/results/table/table-layout';

export default Vue.component('DocRowDetails', IRow.extend({
	props: { row: Object as () => DocRowData, },
}));
